import { AccountInfo, AccountInfoCompany } from "./reducer";

export const TransformAuthResponse = (response: AuthResponse): AccountInfo => {
  return {
    apiKey: response.apiKey,
    companyCity: response.companyCity,
    companyCountry: response.companyCountry,
    companyName: response.companyName,
    companyPostalCode: response.companyPostalCode,
    companyStreet: response.companyStreet,
    companyVatId: response.companyVatId,
    firstName: response.firstName,
    lastName: response.lastName,
    mail: response.mail,
    showBiddingType: response.showBiddingType,
    showDetailedTargeting: response.showDetailedTargeting,
    companies: response.companies ? response.companies : [],
    isAdmin: response.isAdmin ?? false,
  };
};

export interface AuthResponse {
  jwtToken: string;
  mail: string;
  firstName: string;
  lastName: string;
  companyName: string;
  companyStreet: string;
  companyCity: string;
  companyPostalCode: string;
  companyCountry: string;
  companyVatId: string | null;
  apiKey: string;
  showBiddingType: boolean;
  showDetailedTargeting: boolean;
  companies: AccountInfoCompany[];
  isAdmin: boolean;
}
